import React from 'react'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import Confirm from 'views/confirm/confirm'
import generalActions from 'redux/actions/generalActions'
import { localize } from 'helpers/translator'
import confirmTypes from 'helpers/enums/confirmTypes'

const CONFIRM_TYPE = confirmTypes.GOOGLE_SLIDES_SAVE_MEDIA_FAILED_CONFIRM

const GoogleSlidesSaveMediaPresentationFailed = props => (
	<Confirm
		btTwo={localize('global_ok')}
		isCentered={true}
		alertTitle={localize('googleSlides_saveMediaFailed_title')}
		alertMessage={localize('googleSlides_saveMediaFailed_message')}
		actionButtonType={0}
		actionTwo={() => props.actions.close(CONFIRM_TYPE)}
		closeAction={() => props.actions.close(CONFIRM_TYPE)}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		close: generalActions.closeConfirm,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GoogleSlidesSaveMediaPresentationFailed)

export { GoogleSlidesSaveMediaPresentationFailed }
